import global$1 from './global.js';
import toPositiveInteger$1 from './to-positive-integer.js';

var global = global$1;
var toPositiveInteger = toPositiveInteger$1;
var RangeError = global.RangeError;

var toOffset = function (it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES) throw RangeError('Wrong offset');
  return offset;
};

export { toOffset as default };
